import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface UpdateAccountApiParameter extends ApiParameter {
    account: Partial<AccountModel>;
}

const customHCPUrl = "/api/v2/certificate";
export async function UpdateHCPAccount(parameter: UpdateAccountApiParameter): Promise<ServiceResult<AccountModel>> {
    const params = parameter as unknown as any;
    const formData = new FormData();

    formData.append("phoneNumber", params.account?.phoneNumber || "");
    formData.append("address1", params.account?.address1 || "");
    formData.append("address2", params.account?.address2 || "");
    formData.append("address3", params.account?.address3 || "");
    formData.append("taxId", params.account?.taxIdEin || "");
    formData.append("allCurrentDBA", params.account?.currentDba || "");
    formData.append("state", params.account?.state || "");
    formData.append("country", params.account?.country || "");
    formData.append("city", params.account?.city || "");
    formData.append("postalCode", params.account?.postalCode || "");

    formData.append("is_ship_address", params.account?.isShipAddress || "");
    formData.append("ship_address1", params.account?.shipAddress1 || "");
    formData.append("ship_address2", params.account?.shipAddress2 || "");
    formData.append("ship_address3", params.account?.shipAddress3 || "");
    formData.append("ship_state", params.account?.shipState || "");
    formData.append("ship_country", params.account?.shipCountry || "");
    formData.append("ship_city", params.account?.shipCity || "");
    formData.append("ship_postalCode", params.account?.shipPostalCode || "");

    formData.append("practiceName", params.account?.practiceName || "");
    formData.append("practiceType", params.account?.practiceType || "");
    formData.append("taxCertificate", params.account?.taxCertificate || "");
    formData.append("practitionerCertificate", params.account?.practitionerCertificate || "");

    try {
        const accountModel = await request<ServiceResult<AccountModel>>(customHCPUrl, "POST", {}, formData);
        return {
            result: (accountModel as unknown as any).result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
